import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
type Props = {
  label: string;
  note?: string;
  id?: string;
};
export function OfferBlock({
  label,
  note,
  id
}: Props) {
  return <div className="mx-auto flex w-full max-w-lg flex-col items-center gap-4" data-id="element-38" data-mp="3w3cv7xrgkxrx">
      <CtaButton id={id} data-id="element-39" data-mp="4vidwb0sllyt">{label}</CtaButton>
      {note && <p className="text-center text-[13px] leading-relaxed text-navy-700/80 sm:text-sm" data-id="element-40" data-mp="skb3lpqtmxkz">{note}</p>}
      <Countdown data-id="element-41" data-mp="wl3e0mbfj8iu" />
      <ScarcityBar data-id="element-42" data-mp="wlmx46ctg2yg" />
    </div>;
}